const DialogCloseIcon = ({ color = "#0AC4B2" }: { color?: string }) => {
  return (
    <svg
      data-testid="dialog-close-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
    >
      <circle cx="20" cy="20.5" r="13.75" fill={color} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.42 26.6858C24.9082 27.174 25.6996 27.174 26.1878 26.6858C26.676 26.1976 26.676 25.4062 26.1878 24.918L21.7684 20.4986L26.1878 16.0792C26.6759 15.591 26.6759 14.7996 26.1878 14.3114C25.6996 13.8233 24.9081 13.8233 24.42 14.3114L20.0006 18.7308L15.5812 14.3114C15.093 13.8233 14.3016 13.8233 13.8134 14.3114C13.3253 14.7996 13.3253 15.591 13.8134 16.0792L18.2328 20.4986L13.8134 24.918C13.3252 25.4062 13.3252 26.1976 13.8134 26.6858C14.3015 27.174 15.093 27.174 15.5811 26.6858L20.0006 22.2664L24.42 26.6858Z"
        fill="white"
      />
    </svg>
  );
};

export default DialogCloseIcon;
